import { BreadcrumbsUI } from "./BreadcrumbsUI";
import { StandardProps } from "../componentMap";

export const Breadcrumbs = ({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) => {
  const { aliases } = product;

  const { pimProductId: productId } = aliases;

  const { esiBasepath } = runtimeConfig;

  const breadcrumbPath = `${esiBasepath}/esi/breadcrumbs/product/${productId}`;

  return <BreadcrumbsUI breadcrumbPath={breadcrumbPath} />;
};
